import { render, staticRenderFns } from "./AcknowledgeShipmentsModal.vue?vue&type=template&id=cdbd345e&"
import script from "./AcknowledgeShipmentsModal.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeShipmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports